export default __webpack_public_path__ + "static/media/front-vector.9608326c.svg";